module.exports = __webpack_public_path__ + "resources/icon_28_up_arrow.af7b75c04f76d658.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_up_arrow.png
// module id = 489
// module chunks = 0 1 2 3 4